import { render, staticRenderFns } from "./UploadHolidayDate.vue?vue&type=template&id=72bc4311&scoped=true"
import script from "./UploadHolidayDate.vue?vue&type=script&lang=js"
export * from "./UploadHolidayDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc4311",
  null
  
)

export default component.exports